/**
 * Single source for the Design Library icon used in nav, menus, and design-library UI.
 * Change this file to update the icon everywhere.
 */
import type { LucideIcon } from "lucide-react";

import { Palette } from "lucide-react";

export const DesignLibraryIcon: LucideIcon = Palette;
